import { useDialogForm } from '@mews-commander/form';
import { lt, useDialog } from '@mews/framework';
import { TextKey } from '@mews-commander/enums';
import { DropDownButton, DropdownItem, Icon, IconName } from '@optimus-web/core';
import { DeleteDialog } from '../../../common/DeleteDialog';
import { EditFileForm } from '../forms/EditFileForm';

export const ActionCell = () => {
    const [{ onClose: onDeleteDialogClose, active: isDeleteDialogActive }, openDeleteDialog] = useDialog();

    const [renderEditForm, toggleEditForm] = useDialogForm({
        title: lt(TextKey.ContractsEditAttachmentHeader),
        renderForm: (props) => <EditFileForm {...props} />,
    });

    const handleAttachmentsDelete = () => {
        onDeleteDialogClose();
    };

    return (
        <>
            <DropDownButton icon={IconName.More} size="small" variant="ghost">
                <DropdownItem
                    label={lt('Edit')}
                    leftDetail={<Icon value={IconName.Edit} size="small" />}
                    onClick={toggleEditForm}
                />
                <DropdownItem
                    label={lt('Delete')}
                    leftDetail={<Icon value={IconName.Delete} size="small" />}
                    onClick={openDeleteDialog}
                />
            </DropDownButton>
            <DeleteDialog
                isActive={isDeleteDialogActive}
                onClose={onDeleteDialogClose}
                title={lt(TextKey.ContractAttachmentDeleteConfirmationTitle)}
                description={lt(TextKey.ContractAttachmentDeleteConfirmationDescription)}
                onDelete={handleAttachmentsDelete}
            />
            {renderEditForm()}
        </>
    );
};
